import React, { useEffect, useState } from "react";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../../firebase/FirebaseCredential";
import { RootState } from "../../../store/store";
import {
  Container,
  Title,
  Card,
  Text,
  Group,
  Badge,
  Stack,
  Code,
  TextInput,
  Button,
} from "@mantine/core";
import { useAppSelector } from "../../../hooks/hooks";

export const NotificationTestPage = () => {
  const reduxCompanyId = useAppSelector(
    (state: RootState) => state.session?.company_id,
  );
  const [companyId, setCompanyId] = useState<string>("");

  useEffect(() => {
    if (reduxCompanyId) {
      setCompanyId(reduxCompanyId);
    }
  }, [reduxCompanyId]);

  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAllNotifications = async () => {
      if (!companyId) return;
      setLoading(true);
      setError(null);
      try {
        const q = query(
          collection(db, "companyprofile", companyId, "companynotifications"),
          orderBy("created_at", "desc"),
        );
        const snapshot = await getDocs(q);
        const fetchedDocs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNotifications(fetchedDocs);
      } catch (err: any) {
        console.error("Failed to fetch notifications:", err);
        setError(err.message || "Failed to fetch");
      } finally {
        setLoading(false);
      }
    };

    if (companyId) {
      fetchAllNotifications();
    }
  }, [companyId]);

  if (loading)
    return (
      <Container>
        <Text>Loading notifications...</Text>
      </Container>
    );
  if (error)
    return (
      <Container>
        <Text color="red">Error: {error}</Text>
      </Container>
    );

  return (
    <Container size="md" py="xl">
      <Title order={2} mb="md">
        Notification Test Page
      </Title>
      <Group mb="xl" align="flex-end">
        <TextInput
          label="Company ID"
          value={companyId}
          onChange={(e) => setCompanyId(e.currentTarget.value)}
          placeholder="Enter company ID"
          style={{ flex: 1 }}
        />
      </Group>

      {notifications.length === 0 ? (
        <Text>No documents found in companynotifications.</Text>
      ) : (
        <Stack spacing="md">
          {notifications.map((notif) => (
            <Card
              key={notif.id}
              shadow="sm"
              padding="lg"
              radius="md"
              withBorder
            >
              <Group position="apart" mb="xs">
                <Text weight={500}>{notif.title}</Text>
                <Badge>{notif.type || "UNKNOWN"}</Badge>
              </Group>
              <Text size="sm" color="dimmed" mb="md">
                {notif.message}
              </Text>

              <Text size="xs" weight={600}>
                visible_to:
              </Text>
              <Code block>{JSON.stringify(notif.visible_to, null, 2)}</Code>

              <Text size="xs" weight={600} mt="xs">
                Raw Data:
              </Text>
              <Code block>{JSON.stringify(notif, null, 2)}</Code>
            </Card>
          ))}
        </Stack>
      )}
    </Container>
  );
};

export default NotificationTestPage;
